import React, { useEffect, useRef, useState } from "react";
import ReactECharts from "echarts-for-react";
import AiChartContextRegistration from "@/containers/facility/AiAssistant/AiChartContextRegistration";

export default function EChartsReact({ aiContext, ...props }) {
  const [isMounted, setIsMounted] = useState(false);
  const frameRef = useRef(null);
  const chartRef = useRef(null);
  const hasContext = Boolean(aiContext);
  useEffect(() => { setIsMounted(true); }, []);
  useEffect(() => {
    if (!isMounted || !hasContext || !frameRef.current || typeof ResizeObserver === "undefined") return undefined;
    // The chart library can miss a container-only resize during its async
    // initialization. Observe the frame so drawers and grid changes also fit.
    let previousWidth = frameRef.current.clientWidth;
    let previousHeight = frameRef.current.clientHeight;
    const observer = new ResizeObserver(() => {
      const frame = frameRef.current;
      if (!frame || (frame.clientWidth === previousWidth && frame.clientHeight === previousHeight)) return;
      previousWidth = frame.clientWidth;
      previousHeight = frame.clientHeight;
      const chart = chartRef.current?.getEchartsInstance();
      if (chart && !chart.isDisposed()) chart.resize({ width: "auto", height: "auto" });
    });
    observer.observe(frameRef.current);
    return () => observer.disconnect();
  }, [isMounted, hasContext]);

  if (!isMounted) return null;
  if (!aiContext) return <ReactECharts {...props} />;
  return (
    <div ref={frameRef} className="facility-ai-chart-frame" style={{ ...props.style, height: props.style?.height || 300 }}>
      <AiChartContextRegistration context={aiContext} />
      <ReactECharts ref={chartRef} {...props} style={{ ...props.style, flex: "1 1 0", minHeight: 0, height: 0, width: "100%" }} />
    </div>
  );
}
